var ApplicationProperties = (function () {

    var properties = {};

    return {
        /**
         * @param {String} k
         * @param {*} v
         */
        add: function (k, v) {
            properties[k] = v;
        },

        /**
         * @param {Object} keys
         */
        addMany: function (keys) {
            Object.keys(keys).forEach(function (k) {
                this.add(k, keys[k]);
            }.bind(this));
        },

        /**
         *
         * @param {String} k
         * @param {*} f
         * @returns {*}
         */
        get: function (k, f) {
            var fallback = f || false;

            return typeof properties[k] !== 'undefined' ? properties[k]
                : fallback;
        }
    };
})();
